/**
 * @generated SignedSource<<ade6ac21736a6b6b2a6721140df74c9c>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79

import type { ConcreteRequest } from 'relay-runtime';
export type useSpacesDataMyVisitedSpacesQuery$variables = Record<PropertyKey, never>;
export type useSpacesDataMyVisitedSpacesQuery$data = {
  readonly myVisitedSpaces: {
    readonly nodes: {
      readonly spaces: ReadonlyArray<{
        readonly alias: string | null | undefined;
        readonly icon: {
          readonly path: string;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly name: string | null | undefined;
        readonly status: string | null | undefined;
      } | null | undefined> | null | undefined;
    };
  } | null | undefined;
};
export type useSpacesDataMyVisitedSpacesQuery = {
  response: useSpacesDataMyVisitedSpacesQuery$data;
  variables: useSpacesDataMyVisitedSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 26
      }
    ],
    "concreteType": "MyVisitedSpaces",
    "kind": "LinkedField",
    "name": "myVisitedSpaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "MyVisitedSpacesItems",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": false,
        "selections": [
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "alias"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "myVisitedSpaces(limit:26)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpacesDataMyVisitedSpacesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSpacesDataMyVisitedSpacesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
    "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
    "metadata": {},
    "name": "useSpacesDataMyVisitedSpacesQuery",
    "operationKind": "query",
    "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
  }
};
})();

(node as any).hash = "7082555a280d4e2eb838dda87a12b019";

export default node;
